import type { ReactNode } from 'react'

export function PageHeader({
  title,
  subtitle,
  action,
}: {
  title: string
  subtitle?: ReactNode
  /** The one thing this page creates, kept next to what it lists. */
  action?: ReactNode
}) {
  return (
    <header className="mb-7 flex items-start gap-4">
      <div className="min-w-0 flex-1">
        <h1 className="text-ink-900 text-2xl font-semibold tracking-tight">{title}</h1>
        {subtitle ? <p className="text-ink-700 mt-1.5 max-w-2xl text-sm">{subtitle}</p> : null}
      </div>
      {action === undefined ? null : <div className="shrink-0">{action}</div>}
    </header>
  )
}

export function StatTiles({ items }: { items: { label: string; value: number | string }[] }) {
  return (
    // Columns follow the item count so a guest, who gets no headcount tile,
    // does not see an empty cell where it would have been.
    <dl
      className="border-line bg-line mb-8 grid grid-cols-2 gap-px border"
      style={{ gridTemplateColumns: `repeat(${Math.min(items.length, 4)}, minmax(0, 1fr))` }}
    >
      {items.map((item) => (
        <div key={item.label} className="bg-surface px-4 py-3.5">
          <dd className="text-ink-900 text-2xl font-semibold tabular-nums">{item.value}</dd>
          <dt className="text-ink-500 mt-1 font-mono text-[10px] tracking-widest uppercase">
            {item.label}
          </dt>
        </div>
      ))}
    </dl>
  )
}

export function DemoBadge({ label }: { label: string }) {
  return (
    <p className="border-brand-300 bg-brand-50 text-brand-700 mb-6 rounded border-s-2 px-3 py-2 font-mono text-xs">
      {label}
    </p>
  )
}
